const config = {
    urls: {
        api: process.env.NODE_ENV === "development" ? "https://k12.local" : window.location.origin, // Cp
        // api: process.env.NODE_ENV === "development" ? "http://k12.local" : window.location.origin, // Mooc
        // api: process.env.NODE_ENV === "development" ? "http://gdtd.local" : window.location.origin, // Mooc
        login: process.env.NODE_ENV === "development" ? "/#/signIn" : "/dang-nhap",
        // api: "https://truongquansu.truonghoc247.vn",
    },
    locale: {
        default: "vi"
    }
}

export default config;
